import { createSelector } from "reselect";

import { RootState } from "app/store/rootReducer";

export const stateSelector = (state: RootState) => state.aggregations;
export const aggregationSelector = createSelector(stateSelector, (state) => state.aggregation);
export const aggregationLoadingSelector = createSelector(stateSelector, (state) => state.isLoading);
export const aggregationsInvalidateKeySelector = createSelector(stateSelector, (state) => state.invalidateKey);
